function calQty (item) {
  if (
    item.cartonStartNo != null &&
    item.cartonEndNo != null &&
    item.perCartonQty != null
  ) {
    if (item.cartonEndNo - item.cartonStartNo + 1 != 0) {
      // item.perCartonQty = this.perCarton(item)
      item.shippedCarton = item.cartonEndNo - item.cartonStartNo + 1
      item.totalQty = item.shippedCarton * item.perCartonQty
    }
  }
}

export {
  calQty
}